export const environment = {
    production: true,
    apiV1BaseUrl: 'https://api.stable.controlant.com/v1',
    apiV2BaseUrl: 'https://api.stable.controlant.com/v2',
    apiAccountV3BaseUrl: 'https://api.stable.controlant.com/account/v3',
    apiCommonV3BaseUrl: 'https://api.stable.controlant.com/common/v3',
    authTokenPath: 'https://api.stable.controlant.com/auth/v3/token',
    ssoApiPath: 'https://sso.stable.controlant.com',
    baseUrl: 'https://account.stable.controlant.com',
    isChina: false,
    microFrontends: {
        auditTrails: {
            scmUrl: 'https://scm.stable.controlant.com',
            liveDate: '2023-05-13',
            maxDate: '2025-08-31',
            remoteEntry: '//audit-trail-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        controlPanel: {
            remoteEntry: '//control-panel-mfe.stable.controlant.com/remoteEntry.js'
        },
        usersAdmin: {
            remoteEntry: '//users-admin-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        accessManagement: {
            remoteEntry: '//access-management-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        companySettings: {
            remoteEntry: '//company-settings-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        products: {
            remoteEntry: '//products-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        projects: {
            remoteEntry: '//projects-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        reportSubscriptions: {
            remoteEntry: '//report-subscriptions-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        userSettings: {
            remoteEntry: '//user-settings-mfe.stable.controlant.com/assets/remoteEntry.js'
        },
        shipmentProperties: {
            remoteEntry: '//shipment-properties-mfe.stable.controlant.com/assets/remoteEntry.js'
        }
    },
    authConfig: {
        domain: 'https://login.stable.controlant.com',
        clientId: 'sPz7E437cAFa1khrkx0EzhiyMJvPYbnY',
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: 'controlant'
        }
    }
};
